import React from 'react';
import { ChevronRight } from 'lucide-react';
import { formatRelativeTime } from '../../../shared/utils/dateUtils';
import { DEFAULT_GROUP_COLUMNS } from '../config/groupColumns';
import { TABLE_STYLES } from '../styles/dataTableStyles';

const GroupRow = ({ group, onRowClick, columns, styles: stylesProp }) => {
  const styles = stylesProp || TABLE_STYLES;

  const getCellValue = (columnKey) => {
    // Fixed columns
    switch (columnKey) {
      case 'group_id': {
        const raw = group.groupId || '';
        if (!raw) return '—';
        const s = String(raw);
        if (s.length <= 20) return s;
        return `${s.slice(0, 10)}...${s.slice(-8)}`;
      }
      case 'member_count':
        return group.memberCount != null ? group.memberCount.toLocaleString() : '0';
      case 'last_updated_at':
        if (!group.updatedAt) return 'N/A';
        return formatRelativeTime(new Date(group.updatedAt));
      case 'created_at':
        if (!group.createdAt) return 'N/A';
        return formatRelativeTime(new Date(group.createdAt));
      default: {
        // Custom property column
        const val = group.customProperties?.[columnKey];
        if (val === null || val === undefined) return '—';
        if (Array.isArray(val)) return val.join(', ');
        if (typeof val === 'object') return JSON.stringify(val);
        return String(val);
      }
    }
  };

  const getAlignmentClass = (columnKey) => {
    return columnKey === 'group_id' ? 'text-left' : 'text-center';
  };

  const displayColumns =
    columns && columns.length > 0 ? columns : DEFAULT_GROUP_COLUMNS.order;

  return (
    <tr
      onClick={() => onRowClick && onRowClick(group)}
      className="cursor-pointer transition-colors"
      style={{ borderBottom: `1px solid ${styles.borderColor}`, backgroundColor: 'transparent' }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = styles.secondaryBg)}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
    >
      {displayColumns.map((columnKey) => {
        const alignmentClass = getAlignmentClass(columnKey);
        const value = getCellValue(columnKey);
        return (
          <td key={columnKey} className={`px-6 py-3 whitespace-nowrap ${alignmentClass}`}>
            <div className="text-sm" style={{ color: styles.textPrimary, fontFamily: 'Raleway, sans-serif' }}>
              <span title={typeof value === 'string' ? value : ''}>{value || '—'}</span>
            </div>
          </td>
        );
      })}
      <td className="px-6 py-3 whitespace-nowrap text-right">
        <ChevronRight className="h-4 w-4 inline" style={{ color: styles.textSecondary }} />
      </td>
    </tr>
  );
};

export default GroupRow;
